import { useEffect, useRef } from 'react';

/**
 * Check if a component was already rendered (does not force a rerender)
 */
export function useHasComponentRendered(): boolean {
  const hasRendered = useRef(false);
  useEffect(() => {
    hasRendered.current = true;
  }, []);
  return hasRendered.current;
}
